import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from 'src/environments/environment';
import { RobotsWebComponentModule } from 'src/modules/robots/robots.webcomponent.module';

import 'codemirror/mode/xml/xml';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(RobotsWebComponentModule, {
    // defaultEncapsulation: ViewEncapsulation.None,
  })
  .catch((err) => console.log(err));
